<template>
    <div class="apple">
        <div
            class="apple-button"
            @click="buttonClick"
        >
            <div class="apple-button__icon"><img
                src="/icons/pages/integrations/apple/icon.svg"
                alt="apple button-icon"
            ></div>
            <div class="apple-button__text">Sign in with apple</div>
        </div>
    </div>
</template>

<script>
    import {INTEGRATION_AUTH_STORAGE_KEY} from '../integrationHelper';

    export default {
        name: 'apple',
        props: {
            integrationCards: {
                type: Array,
                required: true,
            },
            currentLocation: {
                type: String,
                default: '',
            },
        },
        methods: {
            buttonClick() {
                const integrationType = 'adsearch';
                const integration = this.integrationCards.find((card) => card.type === integrationType);
                let closedByCode = false;
                const popup = window.open(
                    `https://appleid.apple.com/auth/oauth2/v2/authorize?access_type=offline&client_id=${integration.data.client_id}&redirect_uri=${this.currentLocation}&response_type=code&scope=searchads&state=${integration.data.state}`,
                    'DescriptiveWindowName',
                    'resizable,scrollbars,status',
                );
                const self = this;
                const popupTick = setInterval(function () {
                    if (popup.closed) {
                        if (!closedByCode) {
                            self.$toastr.longError(
                                'Integration failed. Closed by user',
                            );
                        }
                        closedByCode = false;
                        clearInterval(popupTick);
                    }
                }, 50);
                
                const finish = function (code) {
                    window.removeEventListener('message', getPopupData, false);
                    window.removeEventListener('storage', getStorageData, false);
                    localStorage.removeItem(INTEGRATION_AUTH_STORAGE_KEY);
                    closedByCode = true;
                    popup.close();
                    self.$emit('addIntegration', code, integrationType);
                };
                // unrelated 'message' events must not detach the listener before the code arrives
                const getPopupData = function (event) {
                    if (event.data && event.data.code) {
                        finish(event.data.code);
                    }
                };
                // fallback for a popup that lost window.opener during the Apple redirects
                const getStorageData = function (event) {
                    if (event.key !== INTEGRATION_AUTH_STORAGE_KEY || !event.newValue) {
                        return;
                    }
                    const authData = JSON.parse(event.newValue);
                    if (authData.state === integration.data.state && authData.code) {
                        finish(authData.code);
                    }
                };
                window.addEventListener('message', getPopupData);
                window.addEventListener('storage', getStorageData);
            },
        },
    };
</script>
<style
    scoped
    lang="scss"
>
    
    .apple {
        align-self: flex-end;
        &-button {
            width: 210px;
            height: 40px;
            border: 1px solid black;
            display: flex;
            align-items: center;
            border-radius: 10px;
            justify-content: center;
            cursor: pointer;
            
            &__icon {
                img {
                    height: 14px;
                    padding-right: 8px;
                }
            }
            &__text{
                font-weight: bold;
                font-size: 18px;
            }
        }
      ::v-deep {
        .integration {
          margin-top: -35px;
        }
      }

    }
</style>